var map = {
	"./community-category/index.sync.tsx": 869,
	"./content-curation/HomepageContentCurationContainer.sync.tsx": 870,
	"./header-navigation/index.sync.tsx": 899,
	"./ideation-destination/filters/ProductAreaFilter.sync.tsx": 916,
	"./knowledge-base/index.sync.tsx": 919,
	"./product-updates-destination/ProductUpdatesOverview.sync.tsx": 931,
	"./widget-custom-html/index.sync.tsx": 1001,
	"./widget-featured-topics/index.sync.tsx": 391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1367;